/**
 * AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
 * Derived from root version.json via scripts/sync-version.mjs.
 */
export const APP_VERSION = '0.2.1';
//# sourceMappingURL=generated-version.js.map